<template>
  <header class="taskbar">
    <div class="buttons" :class="locked ? 'locked' : ''">
      <div v-if="user && !locked">
        <button class="button addBtn" @click="openAddDialog">
          <span class="tooltip">Add Media</span>
          <i class="material-icons">add</i>
        </button>
        <MediaAdd v-if="dialog" />
      </div>
    </div>
    <div class="buttons" :class="locked ? 'locked' : ''">
      <SessionRecorder v-if="user" />
      <FullScreenToggle v-if="user" />
      <BarLocationToggle v-if="user" />
      <LockToggle v-if="user" />
      <LoginPanel :user="user" />
    </div>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import LoginPanel from '@/components/LoginPanel'
import SessionRecorder from '@/components/SessionRecorder'
import BarLocationToggle from '@/components/BarLocationToggle'
import FullScreenToggle from '@/components/FullScreenToggle'
import LockToggle from '@/components/LockToggle'
import MediaAdd from '@/components/MediaAdd'

export default {
  components: {
    LoginPanel,
    FullScreenToggle,
    SessionRecorder,
    LockToggle,
    MediaAdd,
    BarLocationToggle
  },
  computed: {
    ...mapState([
      'user',
      'dialog',
      'locked'
    ])
  },
  methods: {
    ...mapMutations([
      'openAddDialog'
    ])
  }
}
</script>

<style lang="stylus">
</style>